<template>
  <v-container fluid class="pa-0">
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <TeamWidget :teamId="currentUser.team.teamId"></TeamWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0" v-if="userHasRole('ROLE_EVENTING_DATA') && (currentUser.team && currentUser.team.teamId)">
        <LastGameWidget class="flex-grow-1" :teamId="currentUser.team.teamId"></LastGameWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <NextGameWidget :teamId="currentUser.team.teamId"></NextGameWidget>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_REPORTS')">
        <ReportsWidget @heightChange="reportsHeight=$event"></ReportsWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <LastPlayersSearch :style="{ height: ((reportsHeight || charts2Height) ? (reportsHeight || charts2Height) + 'px' : undefined) }"></LastPlayersSearch>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="elevation-2"
          :slides="['pointsVsXPointsChart']"
          @heightChange="charts2Height=$event"
        ></ChartsWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <FavoritesWidget
          :userId="currentUser.id"
          v-bind:style="{'height':charts2Height+'px'}"
        ></FavoritesWidget>
      </v-col>
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="elevation-2"
          :slides="['playerScoutChart']"
          @heightChange="charts3Height=$event"
        ></ChartsWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <CollectionsWidget v-bind:style="{'height':charts3Height+'px'}"></CollectionsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TeamWidget from "./widgets/TeamWidget";
import LastGameWidget from "./widgets/LastGameWidget";
import NextGameWidget from "./widgets/NextGameWidget";
import FavoritesWidget from "./widgets/FavoritesWidget";
import CollectionsWidget from "./widgets/CollectionsWidget";
import ChartsWidget from "./widgets/ChartsWidget";
import ReportsWidget from "./widgets/ReportsWidget";
import LastPlayersSearch from "./widgets/LastPlayersSearch";
import { userHasRole } from "../../utils/functions";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "SportingDirectorDashboard",
  props: {},
  components: {
    TeamWidget,
    LastGameWidget,
    NextGameWidget,
    FavoritesWidget,
    CollectionsWidget,
    ChartsWidget,
    LastPlayersSearch,
    ReportsWidget,
    ScoutingTasksWidget,
    LastScoutingAnalysesWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  data() {
    return {
      loading: false,
      reportsHeight: null,
      charts2Height: null,
      charts3Height: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {},
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SportingDirectorDashboard.vue